import { BOOKING_STATUS, BOOKING_TYPE } from '@lgc/database/types/domains/booking';

// src/simulatorCompanion/names.ts
var PRODUCT_NAME = "SimLock";
var BAY_PIN_LABEL = "Bay PIN";
var CHECK_IN_CODE_HELP = "Enter this PIN on the bay computer to start your session. Anyone in your group can use it.";
function isCheckInCodeVisible(booking, companionEnabled) {
  if (!companionEnabled || !booking.checkInCode) return false;
  return booking.status === BOOKING_STATUS.CONFIRMED || booking.status === BOOKING_STATUS.PENDING;
}

// src/simulatorCompanion/bayPin.ts
function bayPinFor(booking, club) {
  if (!isCheckInCodeVisible(booking, club.companionEnabled)) return null;
  return {
    code: booking.checkInCode,
    bayName: booking.bayName ?? null,
    // Milliseconds, as the eligibility rule counts it: an absolute instant, not a club-time shift.
    opensAt: new Date(booking.startTime.getTime() - club.opensMinutesBefore * 6e4)
  };
}
function isAttendable(b) {
  return b.type !== BOOKING_TYPE.BLOCK && b.status !== BOOKING_STATUS.CANCELLED && b.status !== BOOKING_STATUS.PENDING && b.status !== BOOKING_STATUS.NO_SHOW;
}
function isChained(prev, next) {
  if (prev.endTime.getTime() !== next.startTime.getTime()) return false;
  if (!isAttendable(prev) || !isAttendable(next)) return false;
  if (next.userId != null && next.userId === prev.userId) return true;
  if (next.userId != null && prev.participantUserIds?.includes(next.userId)) return true;
  if (next.teamId != null && next.teamId === prev.teamId) return true;
  return false;
}
function eligibilityForBay(bookings, now, opensMinutesBefore) {
  const sorted = [...bookings].sort((a, b) => a.startTime.getTime() - b.startTime.getTime() || a.id - b.id);
  const opensMs = opensMinutesBefore * 6e4;
  const occupying = sorted.filter((b) => isAttendable(b) && b.startTime <= now && now < b.endTime);
  return sorted.map((b, index) => {
    const prev = index > 0 ? sorted[index - 1] : null;
    const chainedFromId = b.chainedFromId !== void 0 ? b.chainedFromId : prev && isChained(prev, b) ? prev.id : null;
    if (!isAttendable(b)) return { bookingId: b.id, eligibleNow: false, chainedFromId };
    const opensAt = b.startTime.getTime() - opensMs;
    const inWindow = now.getTime() >= opensAt && now <= b.endTime;
    if (!inWindow) return { bookingId: b.id, eligibleNow: false, chainedFromId };
    const blockedBy = occupying.find((o) => o.id !== b.id && o.id !== chainedFromId);
    return { bookingId: b.id, eligibleNow: blockedBy === void 0, chainedFromId };
  });
}
function eligibleBookingNow(bookings, now, opensMinutesBefore) {
  const verdicts = eligibilityForBay(bookings, now, opensMinutesBefore);
  const eligible = verdicts.filter((v) => v.eligibleNow);
  const first = eligible[0];
  return first ? bookings.find((b) => b.id === first.bookingId) ?? null : null;
}

export { BAY_PIN_LABEL, CHECK_IN_CODE_HELP, PRODUCT_NAME, bayPinFor, eligibilityForBay, eligibleBookingNow, isAttendable, isChained, isCheckInCodeVisible };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map